import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";

@Directive({
  selector: '[appSpinner]'
})
export class SpinnerDirective implements OnInit, OnChanges {
  @Input() isLoading: boolean;
  contentText: string;

  constructor(private elem: ElementRef) {
    if (this.elem.nativeElement.innerText !== 'undefined') {
      this.contentText = this.elem.nativeElement.innerHTML;
    }
  }

  ngOnInit(): void {
    if (this.isLoading) {
      this.setSpinner();
    }
  }

  private setSpinner() {
    this.elem.nativeElement.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${this.contentText}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isLoading) {
      this.contentText = this.elem.nativeElement.innerHTML;
      this.setSpinner();
    } else {
      if (this.contentText) {
        this.elem.nativeElement.innerHTML = this.contentText;
      }

    }
  }
}
